// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*[data-v-326225c4]{will-change:height;backface-visibility:hidden}.collapse-enter-active[data-v-326225c4],.collapse-leave-active[data-v-326225c4]{transition-timing-function:linear;transition-property:opacity,height;overflow:hidden}.collapse-enter[data-v-326225c4],.collapse-leave-to[data-v-326225c4]{height:0;opacity:0}", ""]);
// Exports
module.exports = exports;
